

export const INCCallTableColumns = [
  {
    Header: "Phone Number",
    accessor: "phoneNumber",
  },
  {
    Header: "Person Name",
    accessor: "personName",
  },
  {
    Header: "Disposition ID",
    accessor: "dispositionId",
  },
  {
    Header: "Promised Payment Date",
    accessor: "ppDate",
  },
  {
    Header: "Due Amount",
    accessor: "dueAmount",
  },
  {
    Header: "Promised Payment Amount",
    accessor: "ppAmount",
  },
  {
    Header: "Delay Reason",
    accessor: "delayReason",
  },
  {
    Header: "Call Recording",
    accessor: "callRecording",
  },
  {
    Header: "Call Duration",
    accessor: "callDuration",
  },
  {
    Header: "Timestamp",
    accessor: "timestamp",
  },
];
export const MorningCallTableColumns = [
  {
    Header: "Phone Number",
    accessor: "phoneNumber",
  },
  {
    Header: "Person Name",
    accessor: "personName",
  },
  {
    Header: "Region",
    accessor: "region",
  },
  {
    Header: "Language",
    accessor: "language",
  },
  {
    Header: "On Leave?",
    accessor: "workingToday",
  },
  {
    Header: "# Shops To Visit",
    accessor: "totalRetailShop",
  },
  {
    Header: "Markets To Visit",
    accessor: "shopsToBeVisited",
  },
  {
    Header: "Focused product",
    accessor: "focusedProduct",
  },
  {
    Header: "Call Recording",
    accessor: "callRecording",
  },
  {
    Header: "Call Duration",
    accessor: "callDuration",
  },
  {
    Header: "Timestamp",
    accessor: "timestamp",
  },
];

export const EveningCallTableColumns = [
  {
    Header: "Phone Number",
    accessor: "phoneNumber",
  },
  {
    Header: "Person Name",
    accessor: "personName",
  },
  {
    Header: "Region",
    accessor: "region",
  },
  {
    Header: "Language",
    accessor: "language",
  },
  {
    Header: "On Leave?",
    accessor: "workingToday",
  },
  {
    Header: "Office Meeting",
    accessor: "officeMeeting",
  },
  {
    Header: "Calls made today",
    accessor: "callsMadeToday",
  },
  {
    Header: "Productive Calls",
    accessor: "productiveCalls",
  },
  {
    Header: "Productivity",
    accessor: "productivity",
  },
  {
    Header: "Sell Value for today",
    accessor: "sellValueForToday",
  },
  {
    Header: "Call Recording",
    accessor: "callRecording",
  },
  {
    Header: "Call Duration",
    accessor: "callDuration",
  },
  {
    Header: "Timestamp",
    accessor: "timestamp",
  },
];

export const columnsDataCheck = [
  {
    Header: "NAME",
    accessor: "name",
  },
  {
    Header: "PROGRESS",
    accessor: "progress",
  },
  {
    Header: "QUANTITY",
    accessor: "quantity",
  },
  {
    Header: "DATE",
    accessor: "date",
  },
];

export const columnsDataComplex = [
  {
    Header: "NAME",
    accessor: "name",
  },
  {
    Header: "STATUS",
    accessor: "status",
  },
  {
    Header: "DATE",
    accessor: "date",
  },
  {
    Header: "PROGRESS",
    accessor: "progress",
  },
];

export const UnansweredCallTableColumns = [
  {
    Header: "Phone Number",
    accessor: "phoneNumber",
  },
  {
    Header: "Person Name",
    accessor: "personName",
  },
  {
    Header: "Region",
    accessor: "region",
  },
  {
    Header: "Language",
    accessor: "language",
  },

  {
    Header: "Attempts",
    accessor: "numberOfAttempts",
  },
  {
    Header: "Call Status",
    accessor: "callStatus",
  },
  {
    Header: "Timestamp",
    accessor: "timestamp",
  },
]

export const IPACCallTableColumns = [
  {
    Header: "Phone Number",
    accessor: "phoneNumber",
  },
  {
    Header: "Party Selected",
    accessor: "partyName",
  },
  {
    Header: "Rating current Govt.",
    accessor: "ratingCurrentGov",
  },
  {
    Header: "Vote current Govt.?",
    accessor: "voteCurrentGov",
  },
  {
    Header: "Call Recording",
    accessor: "callRecording",
  },
  {
    Header: "Call Duration",
    accessor: "callDuration",
  },
  {
    Header: "Timestamp",
    accessor: "timestamp",
  },
];